<script>



</script>

<template>
  <router-view></router-view>
</template>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
html,
body {
  height: 100%;
}
input{
  margin: 0;
  padding: 0;
}
</style>
